module.exports = __webpack_public_path__ + "f9b7f8da8a8265c48948008ad5a2c0f1.png";